<style lang="scss" scoped>
$leftWidth: 220px;
.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}

.el-checkbox--upload {
  position: absolute;
  left: 100px;
  top: 0;
  display: block;
}

.waring-tag {
  position: absolute;
  top: 0;
  left: 70px;
  padding-left: 10px;
  margin-bottom: 5px;
}
</style>


<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>上传Excel新增订单</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="120px" style="padding-right: 20px">
            <el-form-item label="">
              <a href="../../../../../static/excels/全溯销售订单导入模板.xlsx">
                <el-button type="primary" size="mini">模板下载
                </el-button>
              </a>
            </el-form-item>
            <el-form-item label="Excel文件" style="position: relative">
              <oms-upload-relation :multiple="false" :fileList="attachmentList" accept="xlsx"
                                   @change="changeFiles" @isProgress="onUploadProgress"
                                   :clearUploadFiles="clearUploadFiles"
                                   @refreshCodes="setIsUploading"></oms-upload-relation>
              <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>
              <div class="waring-tag">
                <i class="el-icon-warning"></i> 请选择单个文件上传
              </div>
              <div style="padding-top: 10px">
                <el-button type="primary" @click="onSubmit" :disabled="doing"
                           v-show="attachmentIdList.length>0&&!uploading">提交
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/tools/utils';

export default {
  components: {},
  name: 'importForm',
  props: {},
  data: function () {
    return {
      attachmentList: [],
      attachmentIdList: [],
      uploadingFiles: [],
      index: 0,
      rules: {},
      form: {},
      doing: false,
      title: '上传Excel'
    };
  },
  computed: {
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    }
  },
  watch: {},
  mounted: function () {
  },
  methods: {
    resetForm() {
      this.form = {};
      this.attachmentList = [];
      this.attachmentIdList = [];
      this.isUploading = false;
      this.uploadingFiles = [];
      this.loadingData = false;
      this.isChecked = false;
    },
    setIsUploading(file) {
      this.uploadingFiles.forEach(val => {
        if (file.uid === val.uid) {
          val.isUploading = false;
        }
      })
    },
    onUploadProgress(file) {
      let containFlag = this.uploadingFiles.some(value => value.uid === file.uid);
      if (!containFlag) {
        let newFile = Object.assign({}, file, {isUploading: true});
        this.uploadingFiles.push(newFile);
      }
    },
    changeFiles: function (files) {
      this.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = [];
    },
    onSubmit: function () {
      if (!this.attachmentIdList || this.attachmentIdList.length === 0) {
        this.$notify.warning({
          duration: 1500,
          name: '警告',
          message: '请上传Excel文件'
        });
        return;
      }
      this.doing = true;
      this.title = '上传解析中...';
      this.$http.post(`/bsp-order/upload-file/batch-add/${this.attachmentIdList[0]}`, {}, {timeout: 300000}).then(res => {
        if (res.data) {
          this.$notify.success({
            duration: 2000,
            name: '成功',
            message: res.data
          });
        }
        this.doing = false;
        this.title = '上传Excel';
        // 清空附件列表
        this.resetForm();
        this.$emit('change', res.data);
        this.$emit('right-close');
      }).catch(error => {
        if (error.message.includes('timeout')) {
          this.$notify.warning({
            message: '请求处理中，请勿重复上传文件！'
          });
          this.$emit('right-close');
        } else {
          this.$notify.error({
            message: error.response && error.response.data && error.response.data.msg || '导入Excel新增订单失败'
          });
        }
        this.doing = false;
        this.title = '上传Excel';
        this.resetForm();
      });
    }
  }
};
</script>
